<!--
 * @Author: dgq 370541946@qq.com
 * @Date: 2025-04-23 11:39:38
 * @FilePath: /insuranceagent-ui/src/views/insurance/policy/invoiceSataus.vue
 * @Description: 
-->
<!--
  @name: 查看发票管理
  @author: dgq
  @time:
-->
<template>
	<basic-container>
		<avue-crud
			v-model="formData"
			:page.sync="page"
			v-bind="bindVal"
			v-on="onEvent"
			@on-load="getList"
			@refresh-change="refreshChange"
			@search-reset="searchChange"
			@search-change="searchChange">
			<template slot="menu" slot-scope="{row = {}}">
				<el-button
					v-if="
						row.invoiceList &&
						row.invoiceList.length > 0 &&
						row.invoiceList[0].filePath &&
						(row.brokerType == 2 || row.orderStatus != 5)
					"
					type="text"
					@click="lookInvoice(row)">
					查看发票
					<span class="u-font-weight-bold" :style="row.isDownload ? {color: 'red'} : {color: 'gray'}">
						({{ row.isDownload ? '已下载' : '未下载' }})
					</span>
				</el-button>
			</template>
		</avue-crud>
		<show-pdf-dialog ref="refPdf"></show-pdf-dialog>
	</basic-container>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import {mapGetters} from 'vuex'
import showPdfDialog from '@/components/insurance/showPdfDialog.vue'
import {mixinsPolicyDownload} from '@/mixins/mixinsPolicyDownload'
const option = {
	//模块名字
	name: 'invoiceStatus',
	optionPath: 'invoice/invoiceStatus',
	optionNameList: ['invoiceStatusOption'],
	apiPath: 'invoice/invoice',
	//接口名字
	apiNameList: ['queryInvoice'],
	apiNameAddList: [''],
	apiNameUpdateList: [''],
	apiNameDelList: [''],
	//如有时间搜索，则必填，例如['payTime','payTimeStart','payTimeEnd']
	searchData: [],
	//主键
	rowKey: 'id',
}
export default window.$baseCrud(
	{
		created() {},
		data() {
			return {
				fileType: ['发票'],
			}
		},
		components: {
			showPdfDialog,
		},
		mixins: [mixinsPolicyDownload],
		computed: {
			...mapGetters(['permissions']),
		},
		//引入富文本编辑器
		mounted() {},
		methods: {
			//查看发票
			lookInvoice(rowData) {
				// window.open(url, "_blank");
				this.$refs.refPdf.handleViewSurrenderDocs(rowData, true)
			},
			//列表前操作方法
			listBefore() {},
			dealResponseData(response) {
				//处理数据
				this.onGetPolicyLogList(response)
			},
			//列表后操作方法
			listAfter() {},
			//请求错误
			listError() {},
			//请求finally
			listFinally() {},
			//额外添加请求参数
			addRequestData() {},
		},
	},
	option,
)
</script>

<style lang="scss" scoped></style>
